(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mps-homepage-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sliderSections = document.querySelectorAll('.rag-hhs');
    if (!sliderSections.length) return;

    sliderSections.forEach((sectionNode) => {
      const rootEl = sectionNode;
      const track = rootEl.querySelector('.rag-hhs__track');
      const slides = Array.from(rootEl.querySelectorAll('.rag-hhs__slide'));
      if (!track || !slides.length) return;

      const prevBtn = rootEl.querySelector('[data-role="prev"]');
      const nextBtn = rootEl.querySelector('[data-role="next"]');
      const dotsWrapper = rootEl.querySelector('.rag-hhs__dots');
      const dots = Array.from(rootEl.querySelectorAll('.rag-hhs__dot'));

      // Visible slides respect manual hide + scheduling
      const visibleSlides = slides.filter((slide) => {
        if (slide.hasAttribute('hidden')) return false;
        if (slide.classList.contains('rag-hhs__slide--hidden')) return false;
        return true;
      });

      // If 0 or 1 visible slide: hide nav + dots and bail
      if (visibleSlides.length <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        if (dotsWrapper) dotsWrapper.style.display = 'none';
        return;
      }

      if (prevBtn) prevBtn.style.display = 'block';
      if (nextBtn) nextBtn.style.display = 'block';
      if (dotsWrapper && dots.length) dotsWrapper.style.display = 'flex';

      let currentIndex = 0;
      const totalSlides = visibleSlides.length;

      const autoplayEnabled = sectionNode.dataset.autoplay === 'true';
      const autoplaySpeedSeconds = parseInt(sectionNode.dataset.autoplaySpeed || '5', 10) || 5;
      const autoplayDelay = autoplaySpeedSeconds * 1000;
      let autoplayTimer = null;

      function goToSlide(index) {
        currentIndex = (index + totalSlides) % totalSlides;
        const slideIndex = slides.indexOf(visibleSlides[currentIndex]);
        if (slideIndex === -1) return;

        track.style.transform = 'translateX(-' + slideIndex * 100 + '%)';

        if (dots.length) {
          dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === currentIndex);
          });
        }
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function prevSlide() {
        goToSlide(currentIndex - 1);
      }

      function startAutoplay() {
        if (!autoplayEnabled || autoplayTimer) return;
        autoplayTimer = setInterval(nextSlide, autoplayDelay);
      }

      function stopAutoplay() {
        if (!autoplayTimer) return;
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          stopAutoplay();
          nextSlide();
          startAutoplay();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          stopAutoplay();
          prevSlide();
          startAutoplay();
        });
      }

      if (dots.length) {
        dots.forEach((dot) => {
          const index = parseInt(dot.getAttribute('data-index') || '0', 10) || 0;
          dot.addEventListener('click', () => {
            stopAutoplay();
            goToSlide(index);
            startAutoplay();
          });
        });
      }

      sectionNode.addEventListener('mouseenter', stopAutoplay);
      sectionNode.addEventListener('mouseleave', startAutoplay);

      // Init
      goToSlide(0);
      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
